const FILTER_STORAGE_KEYS = [
  'benchDate',
  'loggedVsAllocatedDate',
  'loggedVsAllocatedFilters',
  'missingApprovalsDate',
  'missingApprovalsFilters',
  'missingSubmissionsDate',
  'myTimesheetsDate',
  'myTimesheetsFilters',
  'projectsDate',
  'projectsFilters',
  'projectsSummaryExpandedProjectIds',
  'timesheetByEmployeeDate',
  'timesheetByEmployeeFilters',
  'weeklyTimesheetDate',
] as const;

export function clearFiltersStorage() {
  if (typeof window === 'undefined') return;

  for (const key of FILTER_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}
